import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from './store'
import '@/router/interceptor'
// import HeerFormEditor from 'heeramis'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
// import '@/components/APIControl'
import '@/assets/global.less'
import '@/components/index.less'
import '@/assets/global.css'
import '@/assets/antd.less'
import i18n from './i18n/i18n'
import '@/components/amisplugin'
import AmisEditor from '@/components/AmisEditor'
// AmisEditor.install = Vue => Vue.component(AmisEditor.name, AmisEditor)


import 'amis/sdk/sdk.js'
import 'amis/sdk/sdk.css'
import 'amis/sdk/iconfont.css'
import 'amis/sdk/helper.css'
import 'amis/lib/themes/default.css'
import 'amis/lib/helper.css'
import 'amis/lib/themes/cxd.css'
import { VuePlugin } from 'vuera'

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VuePlugin)
  install(window.Vue)
}

Vue.config.productionTip = false
Vue.use(Antd)

new Vue({
  render: h => h(App),
  store,
  router,
  i18n
}).$mount('#app')
